import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  DetailTransactionCancelItemType,
  DetailTransactionType,
  PayloadTransactionType,
  PayloadDniDeliveredType,
  postCancelType,
  postDevolutionUndeliveredType,
  ProofType,
  RelationshipResponse,
} from "sagas/types/detailTransactions";
import { RootState } from "store";
import { DetailTransactionInicialStateType } from "./types/detailTransaction";
import {
  deliveryProofType,
  deliveryProofSignType,
  deliveryProofFileType,
} from "pages/transaction/detailTransaction/dniFinish/types";

export const initialState: DetailTransactionInicialStateType = {
  detailTransaction: {
    deliveryValidation: {
      type: "SERIAL_NUMBER",
      codes: ["1234567890","1234567891"]
    },
    transaction: {
      id: 0,
      orderNumber: "",
      transactionCode: "",
      sellerId: "",
      externalPickerId: "",
      state: {
        id: 0,
        name: "",
        tag: "",
      },
      sla: "",
      finishDeliveryTime: "",
      createdAt: "",
      earning: 0,
      deliveryValidation: {
        type: "",
        codes: null
      }
    },
    origin: {
      name: "",
      street: "",
      streetNumber: "",
      locality: "",
      neighborhood: "",
      state: "",
      postalCode: "",
      country: "",
      floor: "",
      apartment: "",
      observation: "",
      latitude: 0,
      longitude: 0,
      formattedAddress: "",
      distance: 0,
    },
    region: {
      id: "",
      name: "",
    },
    trip: {
      id: "",
      order: "",
    },
    destination: {
      name: "",
      street: "",
      streetNumber: "",
      locality: "",
      neighborhood: "",
      state: "",
      postalCode: "",
      country: "",
      floor: "",
      apartment: "",
      observation: "",
      latitude: 0,
      longitude: 0,
      formattedAddress: "",
      distance: 0,
    },
    client: {
      name: "",
      lastName: "",
      identificationNumber: "",
      phone: "",
    },
    products: [],
    transactionHistory: [],
    picker: {
      id: "Sin asignar",
      name: "Sin asignar",
      surname: "",
      phone: {
        countryNumber: "",
        areaNumber: "-",
        number: "-",
      },
    },
    seller: {
      id: 0,
      name: "",
      urlNotification: "",
      tag: "",
    },
    deliveryProof: null,
    proofOfDelivery: null,
  },
  messages: [],
  messageSelected: undefined,
  relationships: [],
};

const SLICE_NAME = "detailTransaction";

export const detailTransactionSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    getDetailTransactionRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<string>
    ) => {},
    getResetMessageDetailTransaccions: (
      state: DetailTransactionInicialStateType
    ) => {
      state.messageSelected = undefined;
    },
    getDetailTransactionSuccess: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<DetailTransactionType>
    ) => {
      state.detailTransaction = action.payload;
    },
    getDetailTransactionError: () => {},
    getDetailTransactionMenssagesRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<string>
    ) => {},
    getDetailTransactionMenssagesSuccess: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<DetailTransactionCancelItemType[]>
    ) => {
      state.messages = action.payload;
    },
    getDetailTransactionMenssagesError: () => {},
    getDetailTransactionDevolutionUndeliveredRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<
        PayloadTransactionType<postDevolutionUndeliveredType>
      >
    ) => {},
    getDetailTransactionDevolutionUndeliveredError: () => {},
    getDetailTransactionReasonsCanceledRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<PayloadTransactionType<postCancelType>>
    ) => {},
    getDetailTransactionReasonsCanceledError: () => {},
    getDetailTransactionFinishReturnedRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<PayloadTransactionType>
    ) => {},
    getDetailTransactionFinishReturnedError: () => {},
    getDetailTransactionFinishLostRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<PayloadTransactionType>
    ) => {},
    getDetailTransactionFinishLostError: () => {},
    getDetailTransactionDniDeliveredRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<PayloadDniDeliveredType>
    ) => {},
    getDetailTransactionDniDeliveredError: () => {},
    setMessageSelected: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<DetailTransactionCancelItemType>
    ) => {
      state.messageSelected = action.payload;
    },
    getProofRequest: (
      state,
      action: PayloadAction<{
        id: string;
        waterMarkText: string;
        type: ProofType;
      }>
    ) => {},
    getProofSuccess: (state: DetailTransactionInicialStateType) => {},
    getProofError: () => {},

    postDeliveryProofRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<deliveryProofType>
    ) => {},
    postDeliveryProofError: () => {},
    postDeliveryProofSuccess: () => {},
    postDeliveryProofSignRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<deliveryProofSignType>
    ) => {},
    postDeliveryProofSignError: () => {},
    postDeliveryProofSignSuccess: () => {},
    postDeliveryProofFileRequest: (
      state: DetailTransactionInicialStateType,
      action: PayloadAction<deliveryProofFileType>
    ) => {},
    postDeliveryProofFileError: () => {},
    postDeliveryProofFileSuccess: () => {},
    getRelationshipsRequest: () => {},
    getRelationshipsSuccess: (
      state,
      action: PayloadAction<RelationshipResponse>
    ) => {
      state.relationships = action.payload.relationships;
    },
    getRelationshipsError: () => {},
  },
});

export const detailTransactionSelector = (state: RootState) =>
  state.detailTransaction;

export const actions = detailTransactionSlice.actions;

export default detailTransactionSlice.reducer;
